export const CATEGORY_BOX_ROW_ITEMS_COUNT = 3;
export const CATEGORY_BOX_IMAGE_MAXIMUM_SIZE = 1500000;
export const CATEGORY_BOX_IMAGE_MINIMUM_SIZE = 1;
